import { GridColDef } from "@mui/x-data-grid";

export const getInitialColumns = (columns: GridColDef[]) => {
  const initialData: Dic<any> = {};
  columns.forEach((elem: GridColDef) => {
    initialData[elem.field] = true;
  });
  return initialData;
};
